import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 'https://ozqkcbcbaablnmgisemk.supabase.co';
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im96cWtjYmNiYWFibG5tZ2lzZW1rIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU5MDM3OTIsImV4cCI6MjA4MTQ3OTc5Mn0.2USUYP2CBkkEo_oKJZuqILtx0Hw-ep0Cv47czxG17Jk';

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase configuration variables');
}

const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

export default supabase;